// FeaturedPostMenu.tsx — the Featured hero's ··· menu (owner, 2026-09-26: "Add the ··· menu
// next to the card"). It is the post's own menu, the one every post and the watch page
// show: Follow, Copy link, Not interested, Mute, Report — or Edit / Delete on your own
// video — with the same dialogs. The Videos page's feeds aren't in the post store, so the
// page is told when the video should leave it (hidden, deleted) or come back (undo).
import { useState } from 'react';
import { useRequireAuth } from '@/hooks';
import type { Post } from '@/core/models/post';
import { PostMoreMenu } from '@/components/PostCard';
import { EditPostDialog } from '@/components/PostCard/EditPostDialog';
import { DeletePostDialog } from '@/components/PostCard/DeletePostDialog';
import { useOwnPostActions } from '@/components/PostCard/useOwnPostActions';
import { ReportModal } from '@/components/ReportModal';

export interface FeaturedPostMenuProps {
  post: Post;
  /** Hidden ("Not interested") or deleted: drop it from the page. */
  onGone: () => void;
  /** "Not interested" undone from its toast. */
  onBack: () => void;
}

export function FeaturedPostMenu({ post, onGone, onBack }: FeaturedPostMenuProps) {
  const requireAuth = useRequireAuth();
  const own = useOwnPostActions(post, { onDeleted: onGone });
  const [reporting, setReporting] = useState(false);
  return (
    <>
      <PostMoreMenu
        post={post}
        isOwn={own.isOwn}
        onReport={() => {
          if (requireAuth('report')) setReporting(true);
        }}
        onEdit={own.openEdit}
        onDelete={own.openDelete}
        onHide={onGone}
        onUnhide={onBack}
      />
      {/* Dialogs portal to the document, so rendering them from inside the card is fine. */}
      {reporting && (
        <ReportModal target={{ kind: 'post', post }} onClose={() => setReporting(false)} />
      )}
      {own.editing && (
        <EditPostDialog
          post={post}
          onClose={own.closeEdit}
          onSave={own.saveEdit}
          editWindowAdvisory={own.editWindowAdvisory}
        />
      )}
      <DeletePostDialog
        open={own.deleting}
        onCancel={own.closeDelete}
        onConfirm={() => void own.confirmDelete()}
      />
    </>
  );
}
